import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CircleInformationFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 3.18C16.82 3.18 20.82 7.16 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18ZM12 7.54C11.4 7.54 10.88 8.06 10.88 8.66C10.88 9.26 11.4 9.78 12 9.78C12.6 9.78 13.12 9.26 13.12 8.66C13.12 8.06 12.6 7.54 12 7.54ZM12.88 10.82H11.12V16.38H12.88V10.82Z" />
    </SvgIcon>
  );
});
